import {ShippingMethod} from 'coreStore/data/orders/types';

/**
 * Represents a ShippingMethod Model
 */
class ShippingMethodModel {
	private shippingMethod: ShippingMethod;

	/**
	 * @constructor
	 * @param {ShippingMethod} shippingMethod - shipping method
	 */
	constructor(shippingMethod) {
		this.shippingMethod = shippingMethod || {};
	}

	/**
	 * Returns shipping method id
	 * @returns {string} id
	 */
	getId() {
		return this.shippingMethod.id || '';
	}

	/**
	 * Returns shipping method description
	 * @returns {string} description
	 */
	getDescription() {
		return this.shippingMethod.description || '';
	}

	/**
	 * Returns shipping method name
	 * @returns {string} name
	 */
	getName() {
		return this.shippingMethod?.name || '';
	}

	/**
	 * Returns shipping price
	 * @returns {number} shipping price
	 */
	getPrice() {
		return this.shippingMethod.price || 0;
	}

	/**
	 * Returns shipping estimated arrival
	 * @returns {number} estimated arrival time
	 */
	getEstimatedArrivalTime() {
		return this.shippingMethod.c_estimatedArrivalTime || '';
	}
}

export default ShippingMethodModel;
